/**
 * Client-side Ask Chckvet clinic gate. Mirrors
 * `server/.../clinic-agent-enabled.helpers.ts` so the dock can appear on a
 * dashboard-only deploy; the server still enforces the same rule on every
 * clinic-agent GraphQL op.
 *
 * - Unset / true → on for every clinic.
 * - Explicit `ask_chckvet_enabled: false` is a kill switch.
 */

import type { TmpFeatureFlags } from '~components/settings/general/tmp-feature-flags/flag-definitions'
import {
    AuthRoles,
    ClinicFieldsFragment,
} from '~graphql/generated/graphql'

export function isAskChckvetEnabledForClinic(
    clinic:
        | Pick<ClinicFieldsFragment, 'tmp_feature_flags'>
        | null
        | undefined,
): boolean {
    if (!clinic) return false
    return readAskChckvetFlag(clinic.tmp_feature_flags) !== false
}

/**
 * Any clinic staff role (ClinicEmployee, ClinicManager, Custom, or
 * group-inherited access) can open Ask Chckvet. The server scopes what the
 * agent can read, propose, and look up to that role's permissions.
 *
 * @param role the caller's role in the active clinic from `useClinic()`
 */
export function canCallerUseAskChckvet(
    role: AuthRoles | undefined,
    isAdmin: boolean,
): boolean {
    if (isAdmin) return true
    return role != null && role !== AuthRoles.User
}

function readAskChckvetFlag(raw: unknown): boolean | undefined {
    if (!raw || typeof raw !== 'object') return undefined
    const value = (raw as TmpFeatureFlags).ask_chckvet_enabled
    return typeof value === 'boolean' ? value : undefined
}
